// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1nRnV","emails":"CreateEditClinics_emails__3Tf35","emailTagLabel":"CreateEditClinics_emailTagLabel__ZAPn9"};